import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const AlertBar = styled.div<{ color?: 'red' | 'blue' }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  position: absolute;
  width: 329px;
  height: 136px;
  right: 24px;
  top: 104px;
  border-radius: 4px;
`;
export const Link = styled.div`
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${responsiveFontSize(16, 1)}

  a {
    font-weight: bold;

    &:hover {
      text-decoration: underline;
      font-weight: 600;
    }
  }

  svg {
    margin-left: 5px;
    font-size: 12px;
  }

  ${mediaQuery('tablet')} {
    justify-content: center;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
`;
